import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react'
import { useStores } from 'hooks/useStores'
import { toast } from 'react-toastify'
import {
  GOOGLE_LINK_OPEN_ACCOUNT_SESSION_KEY,
  GOOGLE_LINK_SUCCESS_QUERY,
  GOOGLE_LINK_SUCCESS_VALUE
} from 'constants/google-sso'

/**
 * After Google bind redirect, the return URL includes `?googleLinked=1`.
 * Shows a success toast, refreshes auth profile, and strips the param from the address bar.
 */
const GoogleLinkedReturnHandler = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { authStore } = useStores()
  const processedKeyRef = useRef<string | null>(null)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (params.get(GOOGLE_LINK_SUCCESS_QUERY) !== GOOGLE_LINK_SUCCESS_VALUE) {
      processedKeyRef.current = null
      return
    }
    const dedupeKey = `${location.pathname}${location.search}${location.hash}`
    if (processedKeyRef.current === dedupeKey) {
      return
    }
    processedKeyRef.current = dedupeKey

    toast.success('Google account linked successfully.', { autoClose: 6000 })
    sessionStorage.setItem(GOOGLE_LINK_OPEN_ACCOUNT_SESSION_KEY, '1')
    void authStore.getMyUser()

    params.delete(GOOGLE_LINK_SUCCESS_QUERY)
    const qs = params.toString()
    navigate(
      { pathname: location.pathname, search: qs ? `?${qs}` : '', hash: location.hash },
      { replace: true }
    )
  }, [location.pathname, location.search, location.hash, navigate, authStore])

  return null
}

export default observer(GoogleLinkedReturnHandler)
